import { isValidElement } from 'react'

import { IllustrationComponentType, IllustrationProps } from './types'

export function isValidIllustrationElement(
  element: React.ReactNode
): element is React.ReactElement<IllustrationProps> {
  if (!isValidElement(element)) {
    return false
  }
  if (!element.type) {
    return false
  }
  return !!(element.type as IllustrationComponentType).__wrappedIllustration
}
